import { Poll } from '@tribeplatform/gql-client/types'

const POLL_KEY = 'poll'

export const getPollKey = (id: Poll['id']) => [POLL_KEY, id]
